import * as yup from 'yup';

import { InvalidTypeValueError } from 'activate-errors';
import { ObjectTypeBase } from '../../types/baseTypes/ObjectTypeBase';
import { TypeContextEnum } from '../../types/properties/TypeContextEnum';
import Types from '../Types';
import { TYPE_GROUP_OTHER } from '../constants';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use JSONType from application-types instead.
 */
export class JSONType extends ObjectTypeBase {
  group = TYPE_GROUP_OTHER;

  name = 'JSON';

  get default(): any {
    return {};
  }

  friendlyName = 'JSON Data';

  contexts = [TypeContextEnum.Block];

  superUserOnly = true;

  buildSchema() {
    return yup.object().nullable();
  }

  deserialize = (value: any) => {
    if (typeof value === 'string') {
      return JSON.parse(value);
    }

    if (typeof value === 'object') {
      return value;
    }

    throw new InvalidTypeValueError(`${value} for JSON is not valid.`);
  };
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use JSON from application-types instead.
 */
const definition = new JSONType();

Types.addBaseType(definition);
export default definition;
